import styled from "styled-components";
import BillingInfoCard from "./BillingInfoCard";
import BillingPlanCardBuilder from "./BillingPlanCardBuilder";
import { buildBillingPlanCards } from "./billingPageConfig";

// #region SCOPED CSS
const StyledBillingPlans = styled.div`
    &.billing-plans-container {
        box-sizing: border-box;
        padding: 0 24px;
        display: flex;
        flex-direction: row;
        gap: 24px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        overflow-x: auto;
    }
    .billing-plans-inner {
        background: #141922;
        border-radius: 25px;
        padding: 16px;
        display: flex;
        flex-direction: row;
        gap: 33px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        overflow: hidden;
        backdrop-filter: blur(52px);
        box-sizing: border-box;
        flex: 1;
        min-width: 1537px;
    }
    .plan-cards-wrapper {
        display: flex;
        flex-direction: row;
        gap: 10px;
        flex: 1;
        align-items: stretch;
        min-width: 1010px;
    }
`;
// #endregion SCOPED CSS

export default function BillingPlans({
    style,
    availableSubscriptionPlans = [],
    activeSubscriptionPlanID = null,
    hasActiveSubscription = false,
    isTermsAccepted = false,
    isInteractionDisabled = false,
    onTermsChange,
    onTermsClick,
    onPrivacyClick,
    onPlanSelected
}) {
    const billingPlanCards = buildBillingPlanCards(availableSubscriptionPlans);
    const activePlan = billingPlanCards.find(plan => plan.subscriptionPlanID === activeSubscriptionPlanID);

    return (
        <StyledBillingPlans style={style} className="billing-plans-container">
            <div className="billing-plans-inner">
                <BillingInfoCard />

                <div className="plan-cards-wrapper">
                    {billingPlanCards.map(plan => {
                        const isPlanAvailable =
                            !!plan.subscriptionPlanID &&
                            availableSubscriptionPlans.some(
                                subscriptionPlan => subscriptionPlan._id === plan.subscriptionPlanID
                            );
                        const isCurrentPlan =
                            isPlanAvailable && plan.subscriptionPlanID === activeSubscriptionPlanID;
                        const ctaLabel = getPlanCTALabel(plan, isCurrentPlan, activePlan, hasActiveSubscription);
                        const isTermsDisabled = isInteractionDisabled || !isPlanAvailable || hasActiveSubscription;
                        const isActionDisabled = isTermsDisabled || !isTermsAccepted;

                        return (
                            <BillingPlanCardBuilder
                                key={plan.id}
                                plan={plan}
                                ctaLabel={ctaLabel}
                                isTermsAccepted={isTermsAccepted}
                                isTermsDisabled={isTermsDisabled}
                                isActionDisabled={isActionDisabled}
                                onTermsChange={onTermsChange}
                                onTermsClick={onTermsClick}
                                onPrivacyClick={onPrivacyClick}
                                onActionClick={() => onPlanSelected?.(plan)}
                            />
                        );
                    })}
                </div>
            </div>
        </StyledBillingPlans>
    );
}

// #region GLOBAL METHODS
function getPlanCTALabel(plan, isCurrentPlan, activePlan, hasActiveSubscription) {
    if (isCurrentPlan) return "SUBSCRIBED";
    if (hasActiveSubscription && plan.level > activePlan?.level) return plan.upgradeCTALabel;
    return plan.ctaLabel;
}
// #endregion GLOBAL METHODS
